import React from "react";
import { Typography } from "@mui/material";
import ResponsiveDrawer from "views/components/ResponsiveDrawer";

function Home() {
  return (
    <ResponsiveDrawer>
      <div style={{ maxWidth: "calc(100vw - 48px)" }}>
        <Typography paragraph>
          漢方に関する様々な検索とデータを提供するウェブサービスです
        </Typography>
      </div>
    </ResponsiveDrawer>
  );
}

export default Home;
